import React from 'react';
import { Link } from 'react-router-dom';

const SampleReportCTA = () => {
  return (
    <div className="bg-gradient-to-r from-blue-900 to-indigo-900 rounded-2xl p-8 text-white">
      <div className="max-w-4xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* Left Side - Value Proposition */}
          <div>
            <div className="inline-flex items-center bg-blue-800 bg-opacity-50 rounded-full px-4 py-2 mb-4">
              <span className="text-blue-200 text-sm font-medium">Real Client Results</span>
            </div>
            
            <h2 className="text-3xl font-bold mb-4">
              See What $990 Gets You: $500K+ Annual Value
            </h2>
            
            <p className="text-blue-100 text-lg mb-6">
              Review an actual professional report showing $315K energy savings + $185K productivity gains 
              with detailed implementation roadmaps and $125K+ in matched grants. Report pays for itself in under 30 days.
            </p>
            
            {/* Key Metrics */}
            <div className="grid grid-cols-3 gap-4 mb-6">
              <div className="text-center">
                <div className="text-2xl font-bold text-white">30 days</div>
                <div className="text-xs text-blue-200">Payback Period</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-white">18mo</div>
                <div className="text-xs text-blue-200">Implementation Plan</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-white">12</div>
                <div className="text-xs text-blue-200">Opportunities Identified</div>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Link 
                to="/sample-esa-report"
                className="flex-1 bg-white text-blue-900 py-3 px-6 rounded-lg font-bold text-center hover:bg-blue-50 transition-colors"
              >
                View Sample Report (Free)
              </Link>
              <Link 
                to="/upgrade-to-professional"
                className="flex-1 bg-emerald-600 text-white py-3 px-6 rounded-lg font-bold text-center hover:bg-emerald-700 transition-colors"
              >
                Order Your Report - $990
              </Link>
            </div>
          </div>
          
          {/* Right Side - Report Preview */}
          <div className="relative">
            <div className="bg-white rounded-lg shadow-2xl p-6 transform rotate-2 hover:rotate-0 transition-transform">
              <div className="text-gray-900">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-bold text-lg">Professional Energy Report</h3>
                  <span className="bg-emerald-100 text-emerald-800 px-2 py-1 rounded-full text-xs font-medium">
                    Sample
                  </span>
                </div>
                
                <div className="space-y-3 mb-4">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Annual Savings:</span>
                    <span className="font-bold text-emerald-600">$280K</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Productivity Gains:</span>
                    <span className="font-bold text-blue-600">$185,000</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Available Grants:</span>
                    <span className="font-bold text-purple-600">$125,000+</span>
                  </div>
                  <div className="flex justify-between border-t pt-2">
                    <span className="text-gray-900 font-medium">Payback Period:</span>
                    <span className="font-bold text-2xl text-emerald-600">30 days</span>
                  </div>
                </div>
                
                <div className="bg-gray-50 p-3 rounded-lg">
                  <h4 className="font-medium text-gray-900 text-sm mb-2">Top Opportunities:</h4>
                  <div className="space-y-1 text-xs text-gray-600">
                    <div>✓ Compressed Air: $89K/year</div>
                    <div>✓ LED Lighting: $67K/year</div>
                    <div>✓ HVAC Upgrade: $48K/year</div>
                    <div className="text-gray-400">+ 9 more detailed...</div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Floating Badge */}
            <div className="absolute -top-2 -right-2 bg-emerald-500 text-white px-3 py-1 rounded-full text-sm font-bold shadow-lg">
              Real Results
            </div>
          </div>
        </div>
        
        {/* Trust Indicators */}
        <div className="border-t border-blue-800 mt-8 pt-6">
          <div className="flex flex-wrap justify-center items-center space-x-8 text-blue-200 text-sm">
            <div className="flex items-center">
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              DOE Certified Methodology
            </div>
            <div className="flex items-center">
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
              </svg>
              90-Day Money-Back Guarantee
            </div>
            <div className="flex items-center">
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              48-Hour Delivery
            </div>
            <div className="flex items-center">
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              2,500+ Companies Served
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SampleReportCTA;